import { Button } from '@/ui/buttons/button/Button.client'
import { useFormState } from '@/ui/form/Form.client'

export function SubmitButton() {
  const { isSubmitting } = useFormState()

  return (
    <Button size="md" type="submit" variant="primary" isLoading={isSubmitting}>
      Submit
    </Button>
  )
}
